import { render, staticRenderFns } from "./MiniCard.vue?vue&type=template&id=553d94f2&scoped=true&"
import script from "./MiniCard.vue?vue&type=script&lang=js&"
export * from "./MiniCard.vue?vue&type=script&lang=js&"
import style0 from "./MiniCard.vue?vue&type=style&index=0&id=553d94f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d94f2",
  null
  
)

export default component.exports